// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/event-tile/event-tile.component.scss
// module id = 277
// module chunks = 0